var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u-select-file",class:{'u-select-file--not-empty': _vm.file}},[_c('p',[_c('input',{ref:"input",attrs:{"type":"file","accept":_vm.typeFilesAccepted},on:{"change":_vm.onInputChange}}),_c('UIcon',{attrs:{"name":"link"}}),_c('span',[_vm._v(" "+_vm._s(_vm.filename ?? "Seleziona o trascina l'immagine di sfondo")+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }